(() => {
  const initialized = new WeakSet();
  function initialize() {
    document.querySelectorAll('[data-mh-film]').forEach(stage => {
      if (initialized.has(stage)) return;
      const video = stage.querySelector('video'), button = stage.querySelector('[data-film-start]');
      if (!video || !button) return;
      initialized.add(stage);
      // Enhance the poster only after a usable play button is bound.
      // Without JavaScript, the HTML keeps native video controls.
      video.controls = false;
      button.addEventListener('click', async () => {
        try {
          if (video.ended) video.currentTime = 0;
          video.controls = true;
          await video.play();
        } catch (_) {
          // Native controls remain available if the browser rejects scripted play.
          stage.classList.add('film-play-failed');
          video.controls = true;
          video.focus();
        }
      });
      video.addEventListener('play', () => {
        video.controls = true;
        document.querySelectorAll('[data-mh-film] video').forEach(other => { if (other !== video) other.pause(); });
        stage.classList.add('is-playing');
        button.hidden = true;
      });
      const stopped = () => { stage.classList.remove('is-playing'); button.hidden = false; };
      video.addEventListener('pause', stopped);
      video.addEventListener('ended', stopped);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(video => video.pause()));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('[data-mh-film] video').forEach(video => video.pause()); });
})();
